import { Outlet, useNavigate } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import AutomationsList from 'modules/automations/components/List'
import { useAutomationContext } from 'modules/automations/lib/automationContext'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export const AutomationsListComponent = observer(() => {
  const { navigation } = useNavigation()
  const { canEditAutomations } = useAutomationContext()

  const backLink = {
    href: navigation.settings.fullPath(),
    label: '',
  }

  const navigate = useNavigate()

  const createAutomationButton = () => {
    return canEditAutomations ? (
      <Button
        iconName="add"
        type="primary"
        onClick={() => navigate(navigation.settings.automations.list.new.fullPath())}
      >
        {i18n.t('automations.index.header.buttons.add_automation')}
      </Button>
    ) : null
  }

  return (
    <ResponsivePage.Body variant="full" showHeader={false} backLink={backLink}>
      <Box flexDirection="rowReverse" padding="s24">
        {createAutomationButton()}{' '}
      </Box>
      <AutomationsList />
      <Outlet />
    </ResponsivePage.Body>
  )
})
